



















































































































































































































//@ts-ignore
import moment from 'moment';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
//@ts-ignore
import ResSplitPane from 'vue-resize-split-pane';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import config from '@/config/index';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion, CodigoAccion } from '@/views/base/VariablesPermisos';
import { fetchConfiguracionStreamax } from './fetchConfiguracionStreamax';
import { isNull } from 'lodash';
import FormRegistInfoStreamax from './RegistInfo/FormRegistInfoStreamax.vue';
import FormTimeSetupStreamax from './TimeSetup/FormTimeSetupStreamax.vue';
import NetworkStreamax from './Network/NetworkStreamax.vue';
import RecordStreamax from './Record/RecordStreamax.vue';
import FormSysConfigHowen from '../Howen/SysConfig/FormSysConfigHowen.vue';
import FormRecSetUpHowen from '../Howen/RecSetup/FormRecSetUpHowen.vue';
import FormNetworkHowen from '../Howen/Network/FormNetworkHowen.vue';
import EstadoCamaras from './EstadoCamaras.vue';
@Component({
  components: {
    ResSplitPane,
    FormRegistInfoStreamax,
    FormTimeSetupStreamax,
    NetworkStreamax,
    RecordStreamax,
    FormSysConfigHowen,
    FormRecSetUpHowen,
    FormNetworkHowen,
    EstadoCamaras,
  },
})
export default class Streamax extends Vue {
  vShow(vShow: any) {
    throw new Error('Method not implemented.');
  }
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  esEdicion: boolean = false;
  sizeSplitPane: number = 300;
  treeViewList: any[] = [];
  openNodes: any[] = [];
  filtro: any;
  searchPatent_tmp1: any;
  currentComponent: any;
  loadingService = new LoadingService();
  isFilter: boolean = false;
  emptyPatentCam: boolean = false;
  $snotify: any;
  formView: string = '';
  isSelected = false;
  marca: String = '';
  key = 0;
  rol: any;
  itemsStreamax: any[] = [
    {
      name: 'RegistInfoStreamax',
      label: 'REGIST INFO',
    },
    {
      name: 'TimeSetUpStreamax',
      label: 'TIME SETUP',
    },
    {
      name: 'NetworkStreamax',
      label: 'NETWORK',
    },
    {
      name: 'RecordStreamax',
      label: 'RECORD',
    },
  ];
  itemsHowen: any[] = [
    { name: 'sysconfigHowen', label: 'SYSCONFIG' },
    { name: 'recsetupHowen', label: 'RECSETUP' },
    { name: 'networkHowen', label: 'NETWORK' },
  ];
  ruts: any[];
  selectedValue: any = { id_dispositivo: '', marca: '' };
  message: any;
  date: any;
  mensaje: any;
  id: any;
  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: CodigoAccion.Consultar,
    visible: false,
  };
  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionEditar];
  get filter() {
    return (item: any, search: any, textKey: any) =>
      item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1;
  }
  async getPatents() {
    let self = this;
    let patente = this.searchPatent_tmp1;
    this.loadingService.showLoading();
    this.ruts = [];
    fetchConfiguracionStreamax({}, 'configCamaras/filtroStreamax')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          response.data.data.LISTA.forEach((e: any) => {
            this.ruts.push(e);
            this.cambiarEstado();
            this.rutsForSelect();
            this.selectedValue = '';
            this.key++;
          });
          return response.data.data.LISTA;
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA);
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al obtener las cámaras');
      })
      .finally(() => {
        this.loadingService.hideLoading();
        this.searchPatent_tmp1 = '';
        this.clear();
      });
  }
  clear() {
    this.treeViewList = [];
    // @ts-ignore
    this.current_patent = {};
    this.formView = '';
    this.marca = '';
  }
  async handleList(item: any) {
    let url = new URL(window.location.href);
    var self = this;
    if (
      item.name === 'sysconfigHowen' ||
      item.name === 'networkHowen' ||
      item.name === 'recsetupHowen' ||
      item.name == 'RegistInfoStreamax' ||
      item.name == 'TimeSetUpStreamax' ||
      item.name == 'NetworkStreamax' ||
      item.name == 'RecordStreamax'
    ) {
      this.formView = item.name;
      this.emptyPatentCam = true;
      this.treeViewList = item.name;
    } else {
      this.clear();
    }
  }
  textoOpcion(item: any) {
    return item.patente_vehiculo + ' - ' + item.id_dispositivo;
  }
  getUserID() {
    let user = localStorage.getItem('user');
    this.id = JSON.parse(user.replace(/'/g, '"')).id;
    console.log(this.id);
    this.rol = JSON.parse(
      user.replace(/'/g, '"')
    ).permisosUsuario[0].nombrePerfil;
  }
  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
    // return 3798;
  }
  cambiarEstado() {
    if (this.ruts.length > 0) {
      this.isFilter = true;
    } else {
      this.isFilter = false;
      this.emptyPatentCam = false;
    }
  }
  dispositivoSeleccionado() {
    const selectedDevice = this.ruts.find((item: any) => {
      return item.id_dispositivo === this.selectedValue;
    });
    const selectedMessage = this.message;
    if (this.selectedValue === '' || !this.selectedValue) {
      this.marca = '';
      this.isSelected = false;
      this.emptyPatentCam = false;
      this.mensaje = '';
    } else {
      this.marca = selectedDevice.marca;
      this.isSelected = true;
      this.mensaje = selectedDevice.mensaje;
      this.date = moment(selectedDevice.fecha_ult_movimiento).format(
        'DD/MM/YYYY HH:mm:ss'
      );
    }
  }
  mounted() {
    this.getPatents();
    this.getUserID();
    if (this.rol == 'Admin Camaras') {
      this.esEdicion = true;
    }
  }
  handleChangePatent() {
    this.ruts = [];
    this.clear();
    var that = this;
    this.loadingService.showLoading();
    setTimeout(function() {
      that.loadingService.hideLoading();
    }, 1000);
    this.getPatents();
    this.dispositivoSeleccionado();
  }
  rutsForSelect() {
    return this.ruts;
  }
}
